// External libraries
import styled from '@emotion/styled';
import type { SerializedStyles } from '@emotion/core';
import { css } from '@emotion/core';

type AnchorType = {
  fontSize?: string;
  lineHeight?: string;
  margin?: string;
};

export const primaryTextButtonStyles = (
  theme: AppTheme.WeasleyTheme,
): SerializedStyles => css`
  background-color: ${theme.button.variant.text.default.background};
  border: ${theme.button.variant.text.default.border};
  color: ${theme.button.variant.text.default.color};
  font-family: ${theme.typography.font.family};
`;

export const getLinkStateStyles = (
  theme: AppTheme.WeasleyTheme,
): SerializedStyles => css`
  &:active {
    color: ${theme.link.hover.color};
  }

  &:hover {
    color: ${theme.link.hover.color};
    text-decoration: underline;
  }

  &:focus {
    ${theme.link.focus};
    text-decoration: underline;
  }
`;

export const StyledAnchor = styled.a<AnchorType>`
  font-size: ${({ fontSize }) => fontSize};
  line-height: ${({ lineHeight, theme }) =>
    lineHeight || theme.link.default.lineHeight};
  margin: ${({ margin }) => margin};
  color: ${({ theme }) => theme.link.default.color};

  text-decoration: none;
  cursor: pointer;

  ${({ theme }) => getLinkStateStyles(theme)}
`;
